import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La laboratorio jam estis senhoma.
    </p>

    <p class="mb-3">
      De la sojlo li ankoraŭfoje ĵetis rigardon al la termostato, kie estis tenataj je konstanta temperaturo Petri-pladoj kun liaj kultivaĵoj. 
      Ĉio estis en ordo.
    </p>

    <p class="mb-3">
      Li elŝaltis la lumon kaj ŝlosis post si la pordon.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3">
      Sekvan matenon la novaj kultivaĵoj estis transplantitaj al nutrivaj substratoj. 
      En grandega laboratoria termostato la globetoj de nutrivaj substratoj estis alpendigitaj al rotacia bazo, kiu malrapide turnis sin ĉirkaŭ la centra grandkapacita lampo, por ke estu egalmezura la distribuo de lumo kaj varmo.
    </p>

    <p class="mb-3">
      En la termostata ŝrankego sametempe estis efektivigataj multaj eksperimentoj, tamen kunlaborantoj de la laboratorio ne malhelpis unu al la alia: la lumo de fremdaj lampoj ne influis ceterajn kultivaĵojn.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>


    <p class="mb-3">
      La eksperimento estis komencita, kaj notita en la registra libro sub la numero 3824 «La elbredo de memekstermanta kultivaĵo».
    </p>
    <p class="mb-3">
      Poste ĉio pasis laŭ normala ordo. 
      Plikreskigo de la tavolo de biomaso, diligenta esploro de internaj ĝiaj procezoj sub mikroskopo kaj laŭ biokemiaj rimedoj (estis prenataj la provaĵoj por analizoj), notoj en la taglibro de la eksperimento.
    </p>
    <p class="mb-3">
      Amasiĝis la materialo por disertaĵo; ankoraŭ kelkajn seriojn da eksperimentoj – kaj eblas granda sukceso. 
      La temo estas multpromesa: tiuj kultivaĵoj, aldonitaj al certaj substratoj, povas atribui al ili tute novajn kvalitojn, tre utilajn por la nacia mastrumado. 
      Oni povas ricevi imponan ekonomian efekton.
    </p>


    <p class="text-center bold mb-3 mt-3">* * *</p>
    

    <p class="mb-3">
      Tamen neniu ekonomia efekto rezultiĝis. 
      Anstataŭ memekstermi, lasinte post si la kulturigitan substraton, tiu kultivaĵo ekstermis ankaŭ la substraton. 
      La 30-an tagon de la eksperimento, la globeto kun la febla kraketo krevis.
    </p>

    <p class="mb-3">
      En ĝiaj restaĵoj oni ne povis trovi la spurojn de la enigita «viva materio», tamen ankaŭ por iuj mastrumaj celoj tiuj disfalantaj en la mano mukozaj buloj ne taŭgis.
    </p>

    <p class="mb-3">
      La unua eksperimento sukcesis nur duone.
    </p>
      

    <p class="text-center bold mb-3 mt-3">* * *</p>
      

    <p class="mb-3">
      Plua esplorado de memekstermantaj kultivaĵoj kondukis lin al multaj eltrovoj; li defendis la tezon, iĝis laŭreato de kelkaj sciencaj premioj.
    </p>
    
    <p class="mb-3">
      Elbreditaj de li kultivaĵoj efektivigadis nun amason de tre bezonataj produktoj, kaj ĝuste je la indikita tempo malaperadis senspure.
    </p>

    <p class="mb-3">
      Sed la unua, sensukcesa globeto nomiĝis en la lingvo de ĝiaj loĝantoj «Tero», kaj multaj milionoj da jaroj forfluis tie antaŭ ol ĝia brila civilizacio venis al sia fino en la glora batalo de siaj grandpotencoj.
    </p>
    `
  )
}

const itemName = {
  esp: 'La eksperimento № 3824'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;